export default __webpack_public_path__ + "static/media/libra.d8e000d6.png";